import React from "react";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light text-center p-4">
      <h1 className="display-4 text-danger mb-3">Something went wrong</h1>
      <p className="lead text-muted mb-4">
        We encountered an error while processing your request. Please try again.
      </p>
      {error && (
        <pre
          className="text-start bg-white p-3 border rounded mb-4 w-75 overflow-auto"
          style={{ maxHeight: "200px" }}
        >
          {error.message}
        </pre>
      )}
      <button
        type="button"
        className="btn btn-primary btn-lg"
        onClick={resetErrorBoundary}
      >
        Try Again
      </button>
    </div>
  );
};

export default ErrorFallback;
